export default __webpack_public_path__ + "static/media/img4.d8af0419.png";